var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCatBack = function SvgCatBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Cat-Back_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M18 2.25c8.699 0 15.75 7.051 15.75 15.75S26.699 33.75 18 33.75 2.25 26.699 2.25 18 9.301 2.25 18 2.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M22.288 34.626H11.466a4.8 4.8 0 0 1-4.804-4.804V12.924h6.548c7.526 0 13.623 6.098 13.623 13.624v3.533a4.547 4.547 0 0 1-4.545 4.545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M15.29 31.915h-.956v-5.411c0-3.398 2.621-6.222 6.008-6.492a.47.47 0 0 1 .506.45v.034a.47.47 0 0 1-.45.473 5.56 5.56 0 0 0-5.108 5.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "m3.871 1.731.113 5.726 5.985-3.453-4.894-2.97a.791.791 0 0 0-1.204.697M17.756 1.731l-.113 5.726-5.985-3.453 4.894-2.97a.791.791 0 0 1 1.204.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M10.812 17.143a7.222 7.222 0 1 0 0-14.445 7.222 7.222 0 0 0 0 14.445"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "m10.068 12.297-.607-.855a.917.917 0 0 1 .214-1.271.9.9 0 0 1 .528-.169h1.204c.506 0 .911.405.911.911a.9.9 0 0 1-.168.529l-.608.855a.915.915 0 0 1-1.485 0zM26.83 27.393a4.547 4.547 0 0 1-4.545 4.544H10.338a3.42 3.42 0 0 1-3.42-3.43v-.08a3.47 3.47 0 0 1 3.487-3.34h1.058c.754 0 1.361-.608 1.361-1.362s-.607-1.361-1.361-1.361h-1.125a6.15 6.15 0 0 0-6.143 6.165v.079c.057 3.375 2.87 6.052 6.244 6.052h11.475l.383-.034a4.547 4.547 0 0 0 4.545-4.545v-2.689zM8.03 9.36a.93.93 0 0 1-.934-.934c0-.517.416-.933.933-.933s.934.416.934.933a.93.93 0 0 1-.934.934M13.77 9.36a.93.93 0 0 1-.934-.934c0-.517.416-.933.934-.933.517 0 .933.416.933.933a.93.93 0 0 1-.933.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "m26.414 10.492-2.084 1.034a.908.908 0 1 0 .808 1.627l.86-.427.061.963a.91.91 0 0 0 1.31.755l2.085-1.034a.908.908 0 1 0-.808-1.627l-.86.427-.062-.963a.91.91 0 0 0-1.31-.755M26.162 5.293a.91.91 0 0 0-1.15.572l-.306.91-.724-.637a.91.91 0 0 0-1.461.392l-.742 2.205a.908.908 0 0 0 1.721.58l.307-.911.724.637a.91.91 0 0 0 1.46-.392l.742-2.205a.91.91 0 0 0-.57-1.15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Cat-Back_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgCatBack;